import { BulkApplyData } from 'lib/types'
import { getDefaultRecordingDataRow } from 'reducers/fell/camera/cameraSlice'
import { useState } from 'react'
import { CameraGroupTableInitialization, columnAcessors } from '../CameraGroupTable/CameraGroupTableInitialization'

const defaultValues = getDefaultRecordingDataRow()

type BulkApplySettings = {
    isBulkApplyModalDisplayed: boolean,
    applyBulkSetting: () => void,
    bulkApplyOptions: any,
    handleBulkApplySelector: (selectedColumnAccessor: string) => void,
    bulkApplyElements: any,
    selectedBulkApplyColumn: string,
    setBulkApplyValue: any,
    getDefaultPropertyValue: (accessor: string) => void
}

export const BulkApplyInitialization = (isModalDisplayed, displayModal, siteDesignPayload, applyBulkSettings): BulkApplySettings => {
  
    const { quantity } = columnAcessors;
    const { bulkApplyElements, bulkApplyOptions } = CameraGroupTableInitialization(siteDesignPayload)

    const isBulkApplyModalDisplayed = isModalDisplayed
    const [selectedBulkApplyColumn, setBulkApplyColumn] = useState(quantity)
    const [bulkApplyValue, setBulkApplyValue] = useState(defaultValues[quantity])

    const bulkApplyDataField = {
        quantity: 0,
        lensType: 10,
        recording: 1,
        hoursPerDay: 2,
        retentionDays: 3,
        codec: 4,
        fps: 5,
        motion: 6,
        complexity: 7,
        resolution: 8,
        bitrateKbit: 9
    };

    const applyBulkSetting = () => {   
        if (selectedBulkApplyColumn && bulkApplyValue) {
            const bulkApplyData: BulkApplyData = {
                bulkApplyDataField: bulkApplyDataField[selectedBulkApplyColumn],
                value: bulkApplyValue.motion ? bulkApplyValue.motion.toString() : bulkApplyValue.toString()
            }
            applyBulkSettings(bulkApplyData);
        }
        displayModal(false)
    }

    const handleBulkApplySelector = (selectedColumnAccessor: string) => {
        setBulkApplyColumn(selectedColumnAccessor)
        setBulkApplyValue(getDefaultPropertyValue(selectedColumnAccessor))
    }

    const getDefaultPropertyValue = (accessorKey): string => {        
        return defaultValues[selectedBulkApplyColumn].motion === undefined ? defaultValues[accessorKey] : defaultValues[accessorKey].motion
    }

    return {
        isBulkApplyModalDisplayed,
        applyBulkSetting,
        bulkApplyOptions,
        handleBulkApplySelector,
        bulkApplyElements,
        selectedBulkApplyColumn,
        setBulkApplyValue,
        getDefaultPropertyValue
    }
}
